import React from "react";
import { IconLetter, IconPhoneCall } from "@kompare/kompare-ui-library";
import logo from "src/assets/images/logo-kompare3.png";
import { i18n, mediaQuery } from "src/common";
import { Button, Divider, Flex, Label, Text, WhatsAppIcon } from 'src/components';
import { colors } from "src/theme";
import styled from "@emotion/styled";
import BaseModal from "./base.modal";

const phoneSvgIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M7.67617 7.17598L6.86146 8.1947C5.59902 7.45297 4.54703 6.40098 3.8053 5.13854L4.82402 4.32383C4.94344 4.22826 5.02783 4.09583 5.06402 3.94723C5.10021 3.79862 5.08614 3.64221 5.02403 3.50245L4.09531 1.411C4.02871 1.26113 3.91104 1.13978 3.7633 1.06859C3.61555 0.997405 3.44732 0.981004 3.2886 1.02231L1.5205 1.48034C1.35559 1.52358 1.21222 1.62573 1.11751 1.7675C1.0228 1.90926 0.983298 2.0808 1.00648 2.24971C1.31669 4.45899 2.33774 6.50722 3.91526 8.08474C5.49278 9.66226 7.54101 10.6833 9.75029 10.9935C9.91913 11.0168 10.0907 10.9774 10.2323 10.8826C10.374 10.7879 10.476 10.6444 10.519 10.4795L10.9777 8.71207C11.019 8.55335 11.0026 8.38512 10.9314 8.23737C10.8602 8.08962 10.7389 7.97196 10.589 7.90536L8.49755 6.97664C8.35782 6.91468 8.20152 6.90063 8.05298 6.93669C7.90443 6.97274 7.77196 7.05686 7.67617 7.17598Z" stroke="#323232" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
) 

const whatsAppSvgIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
    <path d="M9.02344 1.45503C8.56504 0.991993 8.01903 0.624864 7.41726 0.375055C6.81548 0.125247 6.17 -0.00224006 5.51844 2.97848e-05C2.78844 2.97848e-05 0.563438 2.22503 0.563438 4.95503C0.563438 5.83003 0.793438 6.68003 1.22344 7.43003L0.523438 10L3.14844 9.31003C3.87344 9.70503 4.68844 9.91503 5.51844 9.91503C8.24844 9.91503 10.4734 7.69003 10.4734 4.96003C10.4734 3.63503 9.95844 2.39003 9.02344 1.45503ZM5.51844 9.07503C4.77844 9.07503 4.05344 8.87503 3.41844 8.50003L3.26844 8.41003L1.70844 8.82003L2.12344 7.30003L2.02344 7.14503C1.61231 6.48851 1.39401 5.72965 1.39344 4.95503C1.39344 2.68503 3.24344 0.83503 5.51344 0.83503C6.61344 0.83503 7.64844 1.26503 8.42344 2.04503C8.80718 2.42701 9.11129 2.88136 9.31813 3.38174C9.52498 3.88212 9.63045 4.41858 9.62844 4.96003C9.63844 7.23003 7.78844 9.07503 5.51844 9.07503ZM7.77844 5.99503C7.65344 5.93503 7.04344 5.63503 6.93344 5.59003C6.81844 5.55003 6.73844 5.53003 6.65344 5.65003C6.56844 5.77503 6.33344 6.05503 6.26344 6.13503C6.19344 6.22003 6.11844 6.23003 5.99344 6.16503C5.86844 6.10503 5.46844 5.97003 4.99844 5.55003C4.62844 5.22003 4.38344 4.81503 4.30844 4.69003C4.23844 4.56503 4.29844 4.50003 4.36344 4.43503C4.41844 4.38003 4.48844 4.29003 4.54844 4.22003C4.60844 4.15003 4.63344 4.09503 4.67344 4.01503C4.71344 3.93003 4.69344 3.86003 4.66344 3.80003C4.63344 3.74003 4.38344 3.13003 4.28344 2.88003C4.18344 2.64003 4.07844 2.67003 4.00344 2.66503H3.76344C3.67844 2.66503 3.54844 2.69503 3.43344 2.82003C3.32344 2.94503 3.00344 3.24503 3.00344 3.85503C3.00344 4.46503 3.44844 5.05503 3.50844 5.13503C3.56844 5.22003 4.38344 6.47003 5.62344 7.00503C5.91844 7.13503 6.14844 7.21003 6.32844 7.26503C6.62344 7.36003 6.89344 7.34503 7.10844 7.31503C7.34844 7.28003 7.84344 7.01503 7.94344 6.72503C8.04844 6.43503 8.04844 6.19003 8.01344 6.13503C7.97844 6.08003 7.90344 6.05503 7.77844 5.99503Z" fill="#323232"/>
  </svg>
)

const emailSvgIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
    <path d="M10.5 2H2.5C1.94772 2 1.5 2.44772 1.5 3V9C1.5 9.55228 1.94772 10 2.5 10H10.5C11.0523 10 11.5 9.55228 11.5 9V3C11.5 2.44772 11.0523 2 10.5 2Z" stroke="#323232" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.5 3.5L7.015 6.35C6.86064 6.44671 6.68216 6.49801 6.5 6.49801C6.31784 6.49801 6.13936 6.44671 5.985 6.35L1.5 3.5" stroke="#323232" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

const LinkContainerFlexStyle = styled(Flex)({
  display: 'none !important',
  [mediaQuery('tablet')]: {
    display: 'flex !important'
  }
})

const LinkStyle = styled.a({
  color: colors.text1,
  textDecoration: 'underline',
  fontSize: 16,
  '&:hover': {
    textDecoration: 'none'
  },
})

const ButtonContainerFlexStyle = styled(Flex)({
  width: '100%',
  gap: 8,
  flexDirection: 'column',
  maxWidth: 250,
  [mediaQuery('tablet')]: {
    display: 'none !important'
  }
})

const ButtonStyle = styled(Button)({
  width: '100%',
})

const ButtonStyle2 = styled(Button)({
  minWidth: 100,
})

const LogoContainerStyle = styled.div({
  width: 125,
  height: 125,
})

const LogoStyle = styled.img({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
})

const FlexStyle = styled(Flex)({
  maxWidth: 400,
  marginBottom: 30,
  textAlign: 'center',
})

const FlexStyle2 = styled(Flex)({
  marginBottom: 32,
})

const LabelStyle = styled(Label)({
  marginBottom: 16,
})

export interface ContactProps {
  open?: boolean;
  icon?: React.ReactNode;
  onClose?: () => void;
}

export const ContactModal = ({ open = false, icon, onClose }: ContactProps) => (
  <BaseModal open={open} onClose={() => onClose && onClose()}>
    <Flex vertical justify="center" align="center">
      <LogoContainerStyle>
        {!icon ? <LogoStyle src={logo} alt="" /> : icon}
      </LogoContainerStyle>
      <FlexStyle vertical justify="center" align="center">
        <Text type="xxLarge" bold>{i18n.t('components.modals.contactModal.contactText')}</Text>
      </FlexStyle>
      <LinkContainerFlexStyle vertical gap={6}>
        <Flex gap={4} justify="center" align="center">
          <Text type="base" bold>{i18n.t('components.modals.contactModal.linkCallTitle')}</Text>
          {phoneSvgIcon}
          <Text type="base">{i18n.t('components.modals.contactModal.linkCallText')}</Text>
        </Flex>
        <Flex gap={4} justify="center" align="center">
          <Text type="base" bold>{i18n.t('components.modals.contactModal.linkWhatsAppTitle')}</Text>
          {whatsAppSvgIcon}
          <Text type="base">{i18n.t('components.modals.contactModal.linkWhatsAppText')}</Text>
        </Flex>
        <Flex gap={4} justify="center" align="center">
          <Text type="base" bold>{i18n.t('components.modals.contactModal.linkEmailTitle')}</Text>
          {emailSvgIcon}
          <LinkStyle href="mailto:support@kompare.hr">{i18n.t('components.modals.contactModal.linkEmailText')}</LinkStyle>
        </Flex>
      </LinkContainerFlexStyle>
      <ButtonContainerFlexStyle justify="center" align="center">
        <ButtonStyle onClick={() => {window.location.href = "tel:+38515550666"}} size="large" btnType="primary" iconPosition="left" text={i18n.t('components.modals.contactModal.callButton')}>{<IconPhoneCall width={12} height={12} />}</ButtonStyle>
        <ButtonStyle onClick={() => {window.open("https://wa.me/385914688200", "_blank", "noreferrer")}} size="large" btnType="primary" iconPosition="left" text={i18n.t('components.modals.contactModal.whatsAppButton')}>{<WhatsAppIcon width={12} height={12} />}</ButtonStyle>
        <ButtonStyle onClick={() => {window.location.href = "mailto:szop@kompare.hr"}} size="large" btnType="primary" iconPosition="left" text={i18n.t('components.modals.contactModal.emailButton')}>{<IconLetter width={12} height={12} />}</ButtonStyle>
      </ButtonContainerFlexStyle>
      <Divider gap={24} dashed />
      <FlexStyle2 vertical justify="center" align="center">
        <LabelStyle type="small" bold color={colors.text2}>{i18n.t('components.modals.contactModal.workingHoursLabel')}</LabelStyle>
        <Flex vertical justify="center" align="center">
          <Text type="small">{i18n.t('components.modals.contactModal.workingHoursText1')}</Text>
          <Text type="small">{i18n.t('components.modals.contactModal.workingHoursText2')}</Text>
        </Flex>
      </FlexStyle2>
      <Flex vertical justify="center" align="center">
        <ButtonStyle2 onClick={() => onClose && onClose()} size="large" btnType="outlineBlack" text={i18n.t('components.modals.contactModal.closeButton')} />
      </Flex>
    </Flex>
  </BaseModal>
);
